import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useDeliveryInFlightQuery } from './DeliveryInFlight.generated';

import type { RequestPolicy } from 'urql';

export const useDeliveryOrderInFlight = (props?: UseDeliveryOrderInFlightProps) => {
  const { pause, requestPolicy = 'cache-and-network' } = props ?? {};
  const isLoggedIn = useIsLoggedIn();

  // ─── Delivery Order In Flight Query ─────────────────────────────
  const [response] = useDeliveryInFlightQuery({
    variables: { input: { page: 1, take: 3 } },
    requestPolicy,
    pause: Boolean(pause) || !isLoggedIn,
  });

  // ─── Delivery Order In Flight Id ────────────────────────────────
  const ordersResponseData = response.data?.orders;
  const isSuccess = ordersResponseData?.__typename === 'OrdersResponseSuccess';
  const orders = isSuccess ? ordersResponseData.orders : [];
  const inFlightDeliveryOrderId = orders.find(({ isInFlightDelivery }) => isInFlightDelivery)?.id;

  // ─── Navigate To Delivery Order In Flight Screen ────────────────
  const router = useRouter();
  const navigateToDeliveryOrderInFlightScreen = useCallback(() => {
    if (!inFlightDeliveryOrderId) return;

    router.navigate({ pathname: '/delivery-order-in-flight', params: { orderId: inFlightDeliveryOrderId } }); // prettier-ignore
  }, [inFlightDeliveryOrderId, router]);

  return { inFlightDeliveryOrderId, navigateToDeliveryOrderInFlightScreen };
};

type UseDeliveryOrderInFlightProps = Readonly<{
  requestPolicy?: RequestPolicy;
  pause?: boolean;
}>;
